import { useContext } from 'react';
import AuthContext from '../contexts/Auth0Context';
// JWTContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
